module.exports = __webpack_public_path__ + "static/media/settings.7e9e88c2.svg";